<template>
  <div class="page-wrapper member-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="">
        <div class="claim-wrap">
          <div class="claim-contents">
            <div class="claim-title">
              <h1>Claim List - {{ userName }}</h1>
              <div class="claim-btn-wrap">
                <button class=" download-file-btn" v-b-modal.downloadFileModal>
                  <i class="fas fa-download"></i
                  ><span style="margin-left: 10px;" class="ml-2"
                    >Download claim file(s)</span
                  >
                </button>
                <button class=" upload-file-btn" @click="openForm">
                  <i class="fas fa-upload"></i
                  ><span style="margin-left: 10px;" class="ml-2"
                    >Upload claim file(s)</span
                  >
                </button>
              </div>
            </div>
            <file-download-modal :userId="userId" />

            <div class="claim-list-tbl table-responsive">
              <p
                class="text-center"
                style="font-size: 20px;"
                v-if="claimList.length < 1"
              >
                No data found
              </p>
              <table v-else class="table w-100">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Email Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in claimList" :key="index">
                    <td style="width: 48%;">{{ claim.plan_name }}</td>
                    <td :class="claim?.status?.toLowerCase()">
                      <span>{{
                        claim?.status?.charAt(0).toUpperCase() +
                          claim?.status?.slice(1)
                      }}</span>
                    </td>

                    <td>
                      <strong>Added: </strong> {{ formatDate(claim.created_at)
                      }}<br />
                      <span v-if="claim.submitted_at">
                        <strong>Submitted: </strong>
                        {{ formatDate(claim.submitted_at) }}</span
                      >
                    </td>
                    <td class="">
                      <b-badge
                        pill
                        :style="{
                          backgroundColor: statusClass(
                            claim?.email_delivery_status
                          ),
                        }"
                      >
                        {{
                          claim?.email_delivery_status
                            ? claim.email_delivery_status
                            : "N/A"
                        }}
                      </b-badge>
                    </td>

                    <td class="d-flex align-items-center action-icons">
                      <custom-button
                        v-if="
                          claim.status.toLowerCase() === 'submitted' ||
                            claim.status.toLowerCase() !== 'submitted'
                        "
                        :title="
                          claim.status.toLowerCase() === 'submitted'
                            ? 'View File'
                            : 'Edit File'
                        "
                        iconClass="fas fa-eye"
                        @onClicked="viewFile(claim)"
                      />
                      <custom-button
                        v-if="claim.status.toLowerCase() === 'pending'"
                        title="Submit File"
                        iconClass="fas fa-file-upload"
                        @onClicked="openSubmitModal(claim)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <file-submit-modal
                v-if="selectedFiles"
                :files="selectedFiles"
                :claimData="claimData"
                @close="selectedFiles = null"
                :userId="userId"
              />
              <file-upload-modal
                :userId="userId"
                :isEdit="isEdit"
                :row="selectedClaim"
                @close="selectedClaim = null"
                @update-isEdit="isEdit = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import FileUploadModal from "./FileUploadModal.vue";
import FileDownloadModal from "./FileDownloadModal.vue";
import FileSubmitModal from "./FileSubmitModal.vue";

export default {
  components: {
    FileUploadModal,
    FileDownloadModal,
    FileSubmitModal,
  },
  data() {
    return {
      details: [],
      files: [],
      claimList: [],
      claimData: [],
      selectedClaim: null,
      selectedFiles: null,
      isEdit: false,
      breadcrumbItems: [],
    };
  },
  methods: {
    getBreadCrumbs() {
      this.breadcrumbItems = [
        {
          title: "View Members",
          path: {
            name: "ViewMembers",
          },
          active: false,
        },
        {
          title: "Claim List",
          active: true,
        },
      ];
    },
    viewFile(claim) {
      this.isEdit = true;
      this.selectedClaim = claim;
      this.$bvModal.show("uploadFileModal");
    },
    statusClass(status) {
      switch (status?.toLowerCase()) {
        case "sent":
          return "#003964";
        case "queued":
          return "orange";
        case "blacklisted":
          return "#000";
        case "invalid":
          return "red";
        case "delivered":
          return "#05ac05";
        case "opened":
          return "#037003";
        case "bounced":
          return "#ed1c24";
        case "blocked":
          return "#003964";
        case "unsubscribed":
          return "#ff2400";
        default:
          return "black";
      }
    },
    formatDate(date) {
      if (date) {
        const formattedDate = new Date(date);
        return formattedDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      }
      return "";
    },
    openForm() {
      this.selectedClaim = {};
      this.$bvModal.show("uploadFileModal");
    },
    openSubmitModal(claim) {
      this.claimData = claim;
      this.selectedFiles = claim.files;
      this.$bvModal.show("submitFile");
    },
    getClaimList() {
      let loader = this.$loading.show();
      let url = `v2/prudential-claim/list?user_id=${this.userId}`;
      axios
        .get(url)
        .then((res) => {
          if (res.data.status === "success") {
            this.claimList = res.data.data;

            this.claimList.forEach((claim) => {
              claim.status = claim.status == 1 ? "submitted" : "pending";
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  computed: {
    userId() {
      return atob(this.$route.params.userId);
    },
    userName() {
      return this.$route.params.name;
    }
  },
  created() {
    this.getClaimList();
    this.getBreadCrumbs();
  },
};
</script>

<style>
@import "../../../assets/css/claim-list.css";

input[type="file"] {
  display: none;
}

.choose-file-btn {
  display: inline-block;
  padding: 24px 24px;
  background-color: #f1f0ef;
  color: rgb(39, 39, 39);
  border: none;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 12px;
}

.choose-file-btn:focus {
  outline: none;
}
.claim-list-tbl tbody tr td:last-child{
  height: 100%;
  border: none;
}
.claim-list-tbl tbody tr {
  border-right: 1px solid #0000001a;
}

.action-bg {
  cursor: pointer;
  margin-left: 5px;
}
.rep-body-content-wrap {
  padding: 32px;
  background-color: #f3f6f8;
  margin-left: 200px;
  max-width: calc(100% - 200px);
  transition: all ease-in-out 0.3s;
}
</style>
